import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { appStore } from '../../AppStore';
import { BreadcrumbStateInfo } from '../../content/breadcrumbs/BreadcrumbStateInfo';
import { ServerUrls } from '../../ServerUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { ConnectedAllSchedulesSpace } from './ConnectedAllSchedulesSpace';

export interface AllSchedulesSpaceProviderProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls | ServerUrls;
}

const AllSchedulesSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'schedules',
  subspaceName: undefined
};

export const AllSchedulesSpaceProvider: React.FunctionComponent<AllSchedulesSpaceProviderProps> = (props) => {

  React.useEffect(() => {
    appStore.dispatch(updateBreadcrumbs([getSchedulesPlaceBreadcrumb(props.urls)]));
  }, []);

  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllSchedulesSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={false}
        shouldUpdateSort={true}
      >
        <ConnectedAllSchedulesSpace
          angularContext={props.angularContext}
          siteName={props.siteName}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export function getSchedulesPlaceBreadcrumb(urls: SpacesSiteUrls | ServerUrls): BreadcrumbStateInfo {
  const href = urls.schedulesUrl();
  return {
    id: href,
    text: Messages.allSchedules(),
    href: href,
    testId: 'schedules-link'
  };
}
